import React from 'react';

import {emotionStyled, tokens} from '@packages/utilities/styled';

import {Text} from '../../Text';
import {visuallyHiddenStyles} from '../../VisuallyHidden';

export const GroupLabelView = emotionStyled('div')(
  {
    display: 'flex',
    padding: tokens.ui.autocomplete.option.padding,
  },
  {
    componentName: 'AutocompleteGroupLabel',
  }
);

export const AutocompleteGroupLabel = React.forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
    id: string;
    isVisuallyHidden?: boolean;
  }
>(({children, id, isVisuallyHidden = false}, ref) => {
  return (
    <GroupLabelView
      ref={ref}
      style={isVisuallyHidden ? visuallyHiddenStyles : undefined}
    >
      <Text
        colorVariant="primary"
        font="heading"
        id={id}
        role="presentation"
        userSelect="none"
      >
        {children}
      </Text>
    </GroupLabelView>
  );
});
